export default __webpack_public_path__ + "static/media/ss-book-new.177d8f3d.png";